import { ComponentProps, FC } from 'react'
import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { createUseStyles } from 'react-jss'
import cx from 'classnames'

import { Button } from './Button'
import { sansSerifFontFamily } from '../utils/styles'

interface StyleProps {
  textColor: string
  backgroundColor: string
  iconWidth?: number
}

const useStyles = createUseStyles({
  button: {
    height: 56,
    minWidth: 80,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: ({ backgroundColor }: StyleProps) => backgroundColor,
    borderRadius: 16,
    fontFamily: sansSerifFontFamily,
    fontWeight: 700,
    fontSize: 14,
    color: ({ textColor }: StyleProps) => textColor,
    textTransform: 'lowercase',
  },
  icon: {
    width: ({ iconWidth }: StyleProps) => iconWidth,
  },
})

interface Props extends StyleProps, ComponentProps<typeof Button> {
  title?: string
  icon?: string
  iconAlt?: string
  iconWidth?: number
}

export const ColorButton: FC<Props> = flowMax(
  addDisplayName('ColorButton'),
  addProps(({ textColor, backgroundColor, iconWidth }) => ({
    classes: useStyles({ textColor, backgroundColor, iconWidth }),
  })),
  ({ title, icon, iconAlt, onClick, className, classes }) => (
    <Button onClick={onClick} className={cx(classes.button, className)}>
      {icon && <img src={icon} alt={iconAlt} className={classes.icon} />}
      {title}
    </Button>
  )
)
